import * as actionTypes from 'modules/cameras/actionTypes';
import type { OpenPairingModalAction } from 'modules/cameras/types';
import type { MayBe } from 'modules/global/typing/common/common';
import { createReducer } from 'utils/ReduxUtils';

type State = MayBe<string> | null;

const initialState: State = null;

const setTv = (_: State, { payload }: OpenPairingModalAction): State => payload;

const removeTv = (): State => null;

export default createReducer(initialState, {
  [actionTypes.OPEN_PAIRING_MODAL]: setTv,
  [actionTypes.CLOSE_PAIRING_MODAL]: removeTv,
  [actionTypes.POST_CAMERA_TV_PAIRING_SUCCESS]: removeTv,
});
